<script lang="ts">
  export let category = "";
  export let date = "";
</script>

<div class="flex justify-between">
  {#if date}
    <div class="type:h5-eyebrow text-charcoal/50">{date}</div>
  {/if}
  {#if category}
    <h4 class="type:h5-eyebrow text-charcoal/50">
      {@html category}
    </h4>
  {/if}
</div>
